const  ALL_MONTHS = [
    {
      label: "Enero",
      value: 1,
      short: "Jan"
    },
    {
      label: "Febrero",
      value: 2,
      short: "Feb"
    },
    {
      label: "Marzo",
      value: 3,
      short: "Mar"
    },
    {
      label: "Abril",
      value: 4,
      short: "Apr"
    },
    {
      label: "Mayo",
      value: 5,
      short: "May"
    },
    {
      label: "Junio",
      value: 6,
      short: "Jun"
    },
    {
      label: "Julio",
      value: 7,
      short: "Jul"
    },
    {
      label: "Agosto",
      value: 8,
      short: "Aug"
    },
    {
      label: "Septiembre",
      value: 9,
      short: "Sep"
    },
    {
      label: "Octubre",
      value: 10,
      short: "Oct"
    },
    {
      label: "Noviembre",
      value: 11,
      short: "Nov"
    },
    {
      label: "Diciembre",
      value: 12,
      short: "Dec"
    },
  ];

export default ALL_MONTHS;